<app-profile-card
  [profile]="profile"
  class="d-flex align-items-center justify-content-center m-2"
></app-profile-card>
